// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Lz-z","tooltipWrapper":"Mz-z","icon":"Nz-z","tooltip":"Oz-z","content":"Pz-z"};